






































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { dom } from '@fortawesome/fontawesome-svg-core';
import { mapState } from 'vuex';
import comment from '@/components/CommentComponent.vue';
import moment from 'moment';
import User from '@/model/User';
import RoleType from '@/userManagement/RoleType';
import { COLLECTION_ORGANIZATIONS, COLLECTION_POSTS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import PermUtil from '@/model/PermUtil';
import StatusType from '@/model/typelist/StatusType';
import Post from '@/model/Post';
import Edit from '@/components/EditPost.vue';
import {
  Facebook,
  Twitter,
  Linkedin,
  Telegram,
  WhatsApp,
  Google,
} from 'vue-socialmedia-share';

@Component({
  components: {
    comment,
    Edit,
    Facebook,
    Twitter,
    Linkedin,
    Telegram,
    WhatsApp,
  },
})
export default class PostDetailView extends Vue {
  showComments = [] as any;

  editedIndex = -1;

  permUtil = new PermUtil();

  dialog = false;

  dialog1 = false;

  showPost = false;

  editedPost = {};

  url = '';

  async mounted() {
    await this.$store.dispatch('bindPostDetails', this.$route.params.id);
  }
  // eslint-disable-next-line
  postBg(singlePostView: any) {
    return `backgroundColor:${singlePostView.postTile.bgColor}`;
  }
  // eslint-disable-next-line
  postFont(singlePostView: any) {
    return `fontFamily:${singlePostView.postTile.fontFamily}`;
  }

  editPost(singlePostView: any) {
    this.editPost = singlePostView;
    this.showPost = true;
  }

  // get showComp() {
  //   return PermUtil.canCreateOwnPost(this.currentUser);
  // }

  sharePost(id: any) {
    const url = `https://ineed-social.web.app/post/${id}`;
    return url;
  }
  // eslint-disable-next-line
  reportedPost(postObj: any, status: StatusType) {
    Post.updateStatus(postObj, status);
  }

  reportPost(singlePostView: any) {
    this.reportedPost(singlePostView, StatusType.reported);
    this.dialog1 = false;
  }

  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }

  get postReport() {
    return this.$store.state.reportPagePosts;
  }

  deletePost = (id: any) => {
    this.$store.dispatch('removeFromCollection', {
      collection: COLLECTION_POSTS,
      payload: id,
    });
    this.dialog = false;
  };

  likePost(singlePostView: any) {
    const postObj = { ...singlePostView };
    postObj.id = singlePostView.id;
    postObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, singlePostView.createdBy.uid);
    const postCmts = [] as any;
    singlePostView.comments.forEach((cmt: any) => {
      const cmtObj = { ...cmt };
      cmtObj.createdTime = cmt.createdTime;
      cmtObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, cmt.createdBy.uid);
      cmtObj.text = cmt.text;
      postCmts.push(cmtObj);
    });
    postObj.comments = postCmts;
    if (!singlePostView.likes.find((like: any) => like.uid === this.currentUser.uid)) {
      const like = {
        uid: this.currentUser.uid,
      };
      postObj.likes.push(like);
    }
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: singlePostView.id,
      payload: postObj,
    });
    this.editedIndex = 0;
  }

  disLikePost(singlePostView: any) {
    const index = singlePostView.likes.findIndex((like: any) => like.uid === this.currentUser.uid);
    singlePostView.likes.splice(index, 1);
    const postObj = { ...singlePostView };
    postObj.id = singlePostView.id;
    postObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, singlePostView.createdBy.uid);
    const postCmts = [] as any;
    singlePostView.comments.forEach((cmt: any) => {
      const cmtObj = { ...cmt };
      cmtObj.createdTime = cmt.createdTime;
      cmtObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, cmt.createdBy.uid);
      cmtObj.text = cmt.text;
      postCmts.push(cmtObj);
    });
    postObj.comments = postCmts;
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: singlePostView.id,
      payload: postObj,
    });
    this.editedIndex = -1;
  }

  viewComment(singlePostView: any) {
    if (singlePostView.comments.length) {
      this.showComments.push(singlePostView.id);
    }
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  get freshCurrentUser() {
    return this.$store.state.freshCurrentUser;
  }

  formatTime = (time: any) => {
    const date = new Date(time.seconds * 1000);
    return moment(date).fromNow();
  }

  get singlePostView() {
    return this.$store.state.postDetail;
  }
}
